// extracted by mini-css-extract-plugin
module.exports = {"left-panel":"DJUserDetails_left-panel__oKHAo","right-panel":"DJUserDetails_right-panel__2F8_F"};